import React from "react";
import { useCookies } from "react-cookie";
import { deleteAllCookies } from "../utils/helperFunctions";

const UserContext = React.createContext();

const UserProvider = (props) => {
  const [cookies, setCookie] = useCookies(["kioskUser"]);

  function onLogin() {
    setCookie("kioskUser", JSON.stringify({ isLoggedIn: true }), {
      path: "/",
    });
  }

  function onLogout() {
    deleteAllCookies();
  }

  return (
    <UserContext.Provider
      value={{
        onLogin,
        onLogout,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export { UserProvider, UserContext };
